import { render } from "./StatsCard.vue?vue&type=template&id=1de58196"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"
script.render = render

export default script